<template>
  <div class="w-full">
    <div
      class="relative w-full items-center"
      :class="type === 'small' ? '414px:flex' : '2xs:flex'">
      <label
        for="email"
        class="sr-only"
        >{{ label }}</label
      >
      <input
        id="email"
        required
        tabindex="1"
        :disabled="state === 'loading'"
        :value="modelValue"
        name="email"
        type="email"
        class="w-full rounded-full border-none bg-gray-300 py-4 pl-6 text-base font-medium text-white placeholder-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-offset-black disabled:cursor-wait sm:pr-40"
        :placeholder="placeholder"
        :class="state === 'error' ? 'ring ring-red-200' : 'ring-0'"
        @input="emit('update:modelValue', ($event.target as HTMLInputElement).value)" />
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { FormStateType } from '../../../models/form'

  type FormInputProps = {
    state: FormStateType
    placeholder: string
    label: string
    modelValue: string
    type?: string
  }

  defineProps<FormInputProps>()

  const emit = defineEmits<{
    (event: 'update:modelValue', payload: string): void
  }>()
</script>
